<template>
  <div class="card card-custom card-stretch gutter-b">
    <b-overlay :show="loading" variant="white" rounded="sm">
      <div class="card-body pt-3 pb-0">
        <div class="table-responsive">
          <div
            v-show="items.length == 0 && !loading"
            class="alert alert-custom alert-notice alert-light-warning fade show mb-5 mt-5"
            role="alert"
          >
            <div class="alert-icon">
              <i class="flaticon-warning"></i>
            </div>
            <div class="alert-text">
              <strong>Búsqueda sin resultados</strong>. Intente nuevamente
              buscando con otros parámetros.
            </div>
            <div class="alert-close"></div>
          </div>

          <table
            class="table table-head-custom table-vertical-center tabla-detalle-comision"
            v-show="items.length > 0 && !loading"
          >
            <thead>
              <tr class="text-left">
                <th style="min-width: 100px">Mes</th>
                <th style="min-width: 100px">Año</th>
                <th style="min-width: 130px">Tipo</th>
                <th style="min-width: 100px">Detalle Comisión</th>
                <th style="min-width: 100px">Boleta/Factura</th>
                <th style="min-width: 130px">Estado</th>
                <th style="min-width: 130px">Motivo</th>
                <th style="min-width: 130px">N° Documento</th>
                <th style="min-width: 150px">Fecha Boleta Factura</th>
                <th style="min-width: 100px">Total a Girar</th>
                <!--<th style="min-width: 140px">Tipo Cambio</th>
                 <th style="min-width: 140px">Monto Comisión Afecta</th>
                <th style="min-width: 140px">Monto Comisión Exenta</th>
                <th style="min-width: 140px">Monto Afecta UF</th>
                <th style="min-width: 140px">Monto Exenta UF</th>
                <th style="min-width: 140px">Impuesto Afecta</th>
                <th style="min-width: 140px">Impuesto Exenta</th>
                <th style="min-width: 140px">Total Afecta</th>
                <th style="min-width: 140px">Total Exenta</th>
                <th style="min-width: 140px">Impuesto Total</th>
                <th style="min-width: 140px">Neto</th> 
                <th style="min-width: 150px">Fecha Creación</th>
                <th style="min-width: 180px">Fecha Actualización</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in items" v-bind:key="i">
                              <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.Mes
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.Anio
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.Movimiento
                  }}</span>
                </td>
                <td
                  class="pl-0 text-center"                 
                >
                  <div v-if="item.Estado != 'EN PROCESO' && item.Estado != 'APROBADO'">
                  
                  <span
                    class="btn btn-icon btn-light btn-sm mx-3"
                    @click="obtenerRetenciones(item)"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <svg
                        version="1.1"
                        viewBox="0 0 24 24"
                        height="24px"
                        width="24px"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title xmlns="http://www.w3.org/2000/svg">
                          Ver Detalle Comision
                        </title>
                        <desc xmlns="http://www.w3.org/2000/svg" />
                        <defs xmlns="http://www.w3.org/2000/svg" />
                        <g
                          xmlns="http://www.w3.org/2000/svg"
                          id="Stockholm-icons-/-General-/-Settings-1"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect id="bound" x="0" y="0" width="24" height="24" />
                          <path
                            d="M7,3 L17,3 C19.209139,3 21,4.790861 21,7 C21,9.209139 19.209139,11 17,11 L7,11 C4.790861,11 3,9.209139 3,7 C3,4.790861 4.790861,3 7,3 Z M7,9 C8.1045695,9 9,8.1045695 9,7 C9,5.8954305 8.1045695,5 7,5 C5.8954305,5 5,5.8954305 5,7 C5,8.1045695 5.8954305,9 7,9 Z"
                            id="Combined-Shape"
                            fill="#000000"
                          />
                          <path
                            d="M7,13 L17,13 C19.209139,13 21,14.790861 21,17 C21,19.209139 19.209139,21 17,21 L7,21 C4.790861,21 3,19.209139 3,17 C3,14.790861 4.790861,13 7,13 Z M17,19 C18.1045695,19 19,18.1045695 19,17 C19,15.8954305 18.1045695,15 17,15 C15.8954305,15 15,15.8954305 15,17 C15,18.1045695 15.8954305,19 17,19 Z"
                            id="Combined-Shape"
                            fill="#000000"
                            opacity="0.3"
                          />
                        </g>
                      </svg>
                    </span>
                  </span>
                   </div>
                  <div v-else>
                      <span
                    class="btn btn-icon btn-light btn-sm mx-3"
                    @click="avisoEnviado()"
                  >
                    <img
                      src="https://img.icons8.com/color/48/000000/check-file.png"
                      width="30"
                    />
                  </span>
                  </div>
                 
                </td>
        
                <td class="pl-0 text-center">
                  <span
                    class="btn btn-icon btn-light btn-sm mx-3"
                    @click="descargarBoletaFactura(item)"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <svg
                        version="1.1"
                        viewBox="0 0 24 24"
                        height="24px"
                        width="24px"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title xmlns="http://www.w3.org/2000/svg">
                          Boleta Factura
                        </title>
                        <desc xmlns="http://www.w3.org/2000/svg" />
                        <defs xmlns="http://www.w3.org/2000/svg" />
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M2,13 C2,12.5 2.5,12 3,12 C3.5,12 4,12.5 4,13 C4,13.3333333 4,15 4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 C2,15 2,13.3333333 2,13 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                            opacity="0.3"
                          />
                          <rect
                            fill="#000000"
                            opacity="0.3"
                            transform="translate(12.000000, 8.000000) rotate(-180.000000) translate(-12.000000, -8.000000) "
                            x="11"
                            y="1"
                            width="2"
                            height="14"
                            rx="1"
                          />
                          <path
                            d="M7.70710678,15.7071068 C7.31658249,16.0976311 6.68341751,16.0976311 6.29289322,15.7071068 C5.90236893,15.3165825 5.90236893,14.6834175 6.29289322,14.2928932 L11.2928932,9.29289322 C11.6689749,8.91681153 12.2736364,8.90091039 12.6689647,9.25670585 L17.6689647,13.7567059 C18.0794748,14.1261649 18.1127532,14.7584547 17.7432941,15.1689647 C17.3738351,15.5794748 16.7415453,15.6127532 16.3310353,15.2432941 L12.0362375,11.3779761 L7.70710678,15.7071068 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                            transform="translate(12.000004, 12.499999) rotate(-180.000000) translate(-12.000004, -12.499999) "
                          />
                        </g>
                      </svg>
                    </span>
                  </span>
                </td>
                <td class="pl-0">
                  <span
                    :class="getColor(item.Estado)"
                    class="label label-lg label-inline font-weight-bold"
                  >
                    {{ capitalizar(item.Estado) }}
                  </span>
                </td>
                <td class="pl-0">
                  <span
                    v-if="item.Motivo != null"
                    class="text-dark-75 d-block font-size-lg"
                    >{{ capitalizar(item.Motivo) }}
                  </span>
                  <span v-else class="text-dark-75 d-block font-size-lg"
                    >-
                  </span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.NumeroDocumento
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-primary d-block font-size-lg">{{
                    item.FechaFacturacionBoleta != "0001-01-01T00:00:00"
                      ? formatearFecha(item.FechaFacturacionBoleta)
                      : "Sin Fecha"
                  }}</span>
                </td>
                <!--td class="pl-0">
                  <span
                    :class="getColor(item.Moneda)"
                    class="label label-lg label-inline font-weight-bold"
                  >
                    {{ item.Moneda }}
                  </span>
                </td-->

                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg texto-derecha">{{
                    formatearPesos(item.TotalComision)
                  }}</span>
                </td>
                <!-- <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.MontoComisionAfecta
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.MontoComisionExenta
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.MontoAfectaUF
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.MontoExentaUF
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    formatearPesos(item.ImpuestoAfecta)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    formatearPesos(item.ImpuestoExenta)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    formatearPesos(item.TotalAfecta)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    formatearPesos(item.TotalExenta)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    formatearPesos(item.ImpuestoTotal)
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    formatearPesos(item.Neto)
                  }}</span>
                </td> -->
                <!-- <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.Mes
                  }}</span>
                </td>
                <td class="pl-0">
                  <span class="text-dark-75 d-block font-size-lg">{{
                    item.Anio
                  }}</span>
                </td> -->
                <!-- <td class="pl-0">
                  <span class="text-primary d-block font-size-lg">{{
                    item.FechaCreacion != "0001-01-01T00:00:00-03:00"
                      ? formatearFecha(item.FechaCreacion)
                      : "Sin Fecha"
                  }}</span>
                </td>

                <td class="pl-0">
                  <span class="text-primary d-block font-size-lg">{{
                    item.FechaCreacion != "0001-01-01T00:00:00-03:00"
                      ? formatearFecha(item.FechaActualizacion)
                      : "Sin Fecha"
                  }}</span>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <v-pagination
          v-model="page"
          :length="pages"
          v-if="pages > 1"
          :total-visible="10"
          min="1"
          step="1"
        ></v-pagination>
      </div>
    </b-overlay>

    <div>
      <b-modal
        id="modal-detalle-comision"
        title="Detalle Comisión"
        hide-footer
        size="lg"
      >
        <DetalleComisionCorredor :comision="comision" :retenciones="retenciones"></DetalleComisionCorredor>
      </b-modal>
    </div>

    <div>
      <b-modal
        id="modal-detalle-liquidacion"
        title="Detalle Comisión"
        hide-footer
        size="xl"
        centered
      >
        <!-- <hr style="margin-top:-30px" /> -->
        <div class="d-flex lg-0">
          <button
            @click="onexport"
            class="btn btn-contempora btn-shadow btn-lg font-weight-bold mr-2"
            style="height: 45.1px; width: 160px"
          >
            <v-icon dark> mdi-file-excel </v-icon> Reporte
          </button>
        </div>
        <br />
        <div class="row">
          <v-data-table
            :headers="headersDetalleLiquidacion"
            :items="detalleLiquidacion"
            :items-per-page="5"
            class="elevation-2 tabla-codebase theme--light col"
            loading-text="Cargando... Espere Por favor"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-text': 'Registros por página',
              'items-per-page-all-text': 'Todas',
            }"
          >
            <template v-slot:[`item.rutCorredor`]="item">
              {{ item.item.rutCorredor }} - {{ item.item.rutCorredorDv }}
            </template>
            <template v-slot:[`item.fechaFacturacionBoleta`]="item">
              {{ formatDate(item.item.fechaFacturacionBoleta) }}
            </template>
            <template v-slot:[`item.fechaCreacion`]="item">
              {{ formatDate(item.item.fechaCreacion) }}
            </template>
            <template v-slot:[`item.endoso`]="item">
              <span
                :class="getColor(item.item.endoso)"
                class="label label-lg label-inline font-weight-bold"
              >
                {{ item.item.endoso == true ? "Si" : "No" }}
              </span>
            </template>
            <template v-slot:[`item.estado`]="item">
              <span
                :class="getColor(item.item.estado)"
                class="label label-lg label-inline font-weight-bold"
              >
                {{ item.item.estado }}
              </span>
            </template>
            <template v-slot:[`item.tipoComision`]="item">
              <span
                :class="getColor(item.item.tipoComision)"
                class="label label-lg label-inline font-weight-bold"
              >
                {{ item.item.tipoComision }}
              </span>
            </template>
            <template v-slot:[`item.moneda`]="item">
              <span
                :class="getColor(item.item.moneda)"
                class="label label-lg label-inline font-weight-bold"
              >
                {{ item.item.moneda }}
              </span>
            </template>
          </v-data-table>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
// import DetalleComision from "@/view/content/widgets/detalleComision/DetalleComision.vue";
import DetalleComisionCorredor from "@/view/content/widgets/detalleComision/DetalleComisionCorredor.vue";
import { GET_RETENCIONES, GET_RETENCIONES_BY_YEAR } from "@/core/services/store/retencion.module";
import {
  GET_LIQUIDACIONES,
  GET_LIQUIDACION_CORREDOR,
  DESCARGAR_BOLETA_FACTURA,
  APROBAR_BOLETA_FACTURA,
  GET_LIQUIDACIONES_CORREDOR,
} from "@/core/services/store/liquidacion.module";
import {
  GET_FACTURACION_COMISION,
  GET_FACTURACION_COMISION_PERIODO,
} from "@/core/services/store/facturacionComision.module";
import XLSX from "xlsx";
import moment from "moment";
export default {
  name: "dataTableWidget",
  components: {
    DetalleComisionCorredor,
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    loading: { type: Boolean, required: true },
    itemKey: String,
    customClickAction: Function,
    pagination: {
      type: Object,
      required: true,
    },
    pages: { type: Number, required: true },
  },
  watch: {
    page: {
      handler() {
        this.$emit("fetch-more", {
          page: this.page,
          page_size: this.pagination.page_size,
          filter: "",
        });
      },
      deep: true,
    },
  },
  computed: {
    // pages () {
    //   //console.log(("registros: " + this.pagination.totalRecords + " , paginas " + this.page_size)
    //     return Math.ceil(this.pagination.totalRecords / this.page_size);
    // }
  },
  data() {
    return {
      page: 1,
      retenciones : null,
      page_size: this.pagination.page_size,
      item: [],
      comision: null,
      detalleLiquidacion: null,
      filtroDetalleComision: {
        rutCorredor: "",
        mes: 0,
        anio: 0,
        codigoAgente: 0,
      },
      headersDetalleLiquidacion: [
        {
          text: "Fecha Creación",
          align: "start",
          sortable: true,
          value: "fechaCreacion",
          width: "170px",
        },
        {
          text: "Mes",
          align: "start",
          sortable: true,
          value: "mes",
          width: "100px",
        },
        {
          text: "Año",
          align: "start",
          sortable: true,
          value: "anio",
          width: "100px",
        },
        {
          text: "Moneda",
          align: "start",
          sortable: true,
          value: "moneda",
          width: "130px",
        },
        {
          text: "Sucursal",
          align: "start",
          sortable: true,
          value: "sucursal",
          width: "130px",
        },
        {
          text: "Rut Contratante",
          align: "start",
          sortable: true,
          value: "rutContratante",
          width: "150px",
        },
        {
          text: "Nombre Contratante",
          align: "start",
          sortable: true,
          value: "nombreContratante",
          width: "250px",
        },
        {
          text: "Código Ramo",
          align: "start",
          sortable: true,
          value: "codigoRamo",
          width: "170px",
        },
        {
          text: "Ramo Fecu",
          align: "start",
          sortable: true,
          value: "ramoFecu",
          width: "200px",
        },
        {
          text: "Póliza",
          align: "start",
          sortable: true,
          value: "poliza",
          width: "150px",
        },
        {
          text: "Endoso",
          align: "start",
          sortable: true,
          value: "endoso",
          width: "130px",
        },
        {
          text: "Prima Neta",
          align: "start",
          sortable: true,
          value: "primaNeta",
          width: "130px",
        },
        {
          text: "% Comisión",
          align: "start",
          sortable: true,
          value: "porcentajeComision",
          width: "150px",
        },
        {
          text: "Monto Comisión",
          align: "start",
          sortable: true,
          value: "montoComision",
          width: "170px",
        },
        {
          text: "Tipo Comisión",
          align: "start",
          sortable: true,
          value: "tipoComision",
          width: "150px",
        },
        {
          text: "Cambio",
          align: "start",
          sortable: true,
          value: "cambio",
          width: "100px",
        },
        {
          text: "Comisión Neta",
          align: "start",
          sortable: true,
          value: "comisionNeta",
          width: "170px",
        },
        {
          text: "Impuesto",
          align: "start",
          sortable: true,
          value: "impuesto",
          width: "130px",
        },
        {
          text: "Comisión Total",
          align: "start",
          sortable: true,
          value: "comisionTotal",
          width: "170px",
        },
        {
          text: "Ajuste v/s fact",
          align: "start",
          sortable: true,
          value: "ajusteVersusFacturacion",
          width: "150px",
        },
        {
          text: "Comisión A Pago",
          align: "start",
          sortable: true,
          value: "comisionAPago",
          width: "170px",
        },
        {
          text: "Descuento Anticipo",
          align: "start",
          sortable: true,
          value: "descuentoAnticipo",
          width: "150px",
        },
        {
          text: "Saldo A Pagar",
          align: "start",
          sortable: true,
          value: "saldoAPagar",
          width: "170px",
        },
        {
          text: "Tipo Documento",
          align: "start",
          sortable: true,
          value: "tipoDocumento",
          width: "170px",
        },
        {
          text: "N° Documento",
          align: "start",
          sortable: true,
          value: "numeroDocumento",
          width: "170px",
        },
        {
          text: "Fecha Fact/Boleta",
          align: "start",
          sortable: true,
          value: "fechaFacturacionBoleta",
          width: "170px",
        },
        {
          text: "Estado",
          align: "start",
          sortable: true,
          value: "estado",
          width: "130px",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },
    makeToast(append = false, texto, titulo, variant) {
      this.$bvToast.toast(texto, {
        title: titulo,
        autoHideDelay: 5000,
        variant: variant,
        toaster: "b-toaster-top-right",
        appendToast: append,
      });
    },
    descargarBoletaFactura(item) {
      this.$store
        .dispatch(DESCARGAR_BOLETA_FACTURA, item.LiquidacionId)
        .then((resultado) => {
          if (resultado != null && resultado.length > 0) {
            let tipoDocumento = "";
            resultado.forEach((element) => {
              if (element == "AFECTA") {
                tipoDocumento = element;
              } else if (element == "EXENTA") {
                tipoDocumento = element;
              } else if (tipoDocumento != "") {
                const url = `data:application/pdf;base64,${element}`;
                const descargar = document.createElement("a");
                const nombreDocumento = `${item.RutCorredor}_${item.CodigoAgente}_${item.Mes}_${item.Anio}_${tipoDocumento}.pdf`;

                tipoDocumento = "";
                descargar.href = url;
                descargar.download = nombreDocumento;
                descargar.click();
                this.makeToast(
                  false,
                  "Documento Descargado",
                  "Aviso",
                  "success"
                );
              }
            });
          } else {
            this.makeToast(
              false,
              "Ha currido un error o el documento no existe",
              "Aviso",
              "danger"
            );
          }
        })
        .catch((error) => {
          this.makeToast(
            false,
            "Ha currido un problema al descargar el documento",
            "Aviso",
            "danger"
          );
        });
    },
    obtenerRetenciones(item) {
        // console.log('obtenerRetenciones item: ', item)
    //   this.$store.dispatch(GET_RETENCIONES).then((response) => {
    //     this.retenciones = response;
    //     this.modalDetalleComision(item);
    //   });
        this.$store.dispatch(GET_RETENCIONES_BY_YEAR, item.Anio).then((response) => {
            this.retenciones = response;
            this.modalDetalleComision(item)
        })
    },
    modalDetalleComision(item) {
      // const submitButton = this.$refs["btn_archivos"];
      // submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store
        .dispatch(GET_LIQUIDACION_CORREDOR, {
          rutCorredor: item.RutCorredor,
          mes: item.Mes,
          anio: item.Anio,
          codigoAgente: item.CodigoAgente,
        })
        .then((resultado) => {
            let newResultado = []
            resultado.forEach((element) => {
                // console.log('element: ', element)
                newResultado.push({
                    ...element,
                    "estado": item.estado,
                    "movimiento": item.tipoMovimiento,
                })
            })
            // console.log('newResultado: ', newResultado)
            this.comision = newResultado;

          // this.comision.estado = item.Estado;
          // this.comision.facturacionComisionId = item.FacturacionComisionId;
          // this.$bus.$emit("resultadoSubida", true);
          this.$bvModal.show("modal-detalle-comision");
          // submitButton.classList.remove(
          //   "spinner",
          //   "spinner-light",
          //   "spinner-right"
          // );
        })
        .catch((resultado) => {
          this.makeToast(
            false,
            "Hubo un problema al obtener los datos: ".concat(resultado),
            "Aviso",
            "danger"
          );
          //   submitButton.classList.remove(
          //     "spinner",
          //     "spinner-light",
          //     "spinner-right"
          //   );
        });
    },
    modalDetalleLiquidacion(item) {
      let monedaFormateada = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 3,
      });
      // const submitButton = this.$refs["btn_archivos"];
      // submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store
        .dispatch(GET_FACTURACION_COMISION_PERIODO, {
          rutCorredor: item.RutCorredor,
          mes: item.Mes,
          anio: item.Anio,
          codigoAgente: item.CodigoAgente,
        })
        .then((resultado) => {
          this.detalleLiquidacion = resultado;

          resultado.forEach((element) => {
            element.comisionNeta = monedaFormateada
              .format(element.comisionNeta.toFixed(3))
              .replace("$", "")
              .replace(",", ".");
            element.comisionTotal = monedaFormateada
              .format(element.comisionTotal.toFixed(3))
              .replace("$", "")
              .replace(",", ".");
            element.comisionAPago = monedaFormateada
              .format(element.comisionAPago.toFixed(3))
              .replace("$", "")
              .replace(",", ".");
          });

          //Guardamos el fitrlo en data, para utilizarlos en la descarga del reporte
          this.filtroDetalleComision.rutCorredor = item.RutCorredor;
          this.filtroDetalleComision.mes = item.Mes;
          this.filtroDetalleComision.anio = item.Anio;
          this.filtroDetalleComision.codigoAgente = item.CodigoAgente;

          // this.detalleLiquidacion.comisionNeta =
          // console.log(this.detalleLiquidacion);
          // this.comision.facturacionComisionId = item.FacturacionComisionId;
          // this.$bus.$emit("resultadoSubida", true);
          if (resultado.length > 0) {
            this.$bvModal.show("modal-detalle-liquidacion");
            this.makeToast(false, "Registros cargados", "Aviso", "success");
          } else {
            this.makeToast(false, "No hay Registros", "Aviso", "danger");
          }

          // submitButton.classList.remove(
          //   "spinner",
          //   "spinner-light",
          //   "spinner-right"
          // );
        })
        .catch((resultado) => {
          //   submitButton.classList.remove(
          //     "spinner",
          //     "spinner-light",
          //     "spinner-right"
          //   );
        });
    },
    formatearPesos(moneda) {
      let monedaFormateada = new Intl.NumberFormat("es-CL");

      return monedaFormateada.format(moneda);
    },
    formatearDolar(moneda) {
      let monedaFormateada = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });

      return monedaFormateada.format(moneda);
    },
    formatearEuro(moneda) {
      let monedaFormateada = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });

      return monedaFormateada.format(moneda).replace("€", "");
    },
    avisoEnviado() {
      this.makeToast(false, "El documento ya fue envíado", "Aviso", "info");
    },
    getColor(valor) {
      if (valor == "PAGADO") return "label-light-success";
      else if (valor == "EN PROCESO") return "label-warning";
      else if (valor == "NO PAGADO") return "label-light-danger";
      else if (valor == "FACTURA") return "label-light-success";
      else if (valor == "NO APROBADO") return "label-light-danger";
      else if (valor == "APROBADO") return "label-success";
      else if (valor == "BOLETA") return "label-light-primary";
      else if (valor == true) return "label-light-success";
      else if (valor == false) return "label-light-danger";
      else if (valor == "UF") return "label-light-success";
      else if (valor == "UTM") return "label-light-primary";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "Afecta") return "label-light-danger";
      else if (valor == "Excenta") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else if (valor == "US$") return "label-light-danger";
      else return "label-light-success";
    },
    capitalizar(valor) {
      if (valor != null) {
        let texto = valor.toLowerCase();
        return texto.charAt(0).toUpperCase() + texto.slice(1);
      }
    },
    formatearFecha(fecha) {
      var fechaFormateada = moment(fecha).format("DD/MM/YYYY");
      return fechaFormateada;
    },
    getPercent(item) {
      return Math.round(
        (item.TotalArchivosCargados / item.TotalArchivos) * 100
      );
    },
    getVariantType(item) {
      let porcentaje = this.getPercent(item);
      if (porcentaje == 100) {
        return "success";
      } else if (porcentaje >= 50) {
        return "warning";
      } else if (porcentaje > 30) {
        return "primary";
      }
      return "danger";
    },
    onexport() {
      let monedaFormateada = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 3,
      });
      this.$store
        .dispatch(GET_FACTURACION_COMISION_PERIODO, this.filtroDetalleComision)
        .then((response) => {
          let archivoSalida = [];
          response.forEach((element) => {
            //Armamos el formato de salida
            let comision = {
              fechaCreacion: element.fechaCreacion.split("T")[0],
              mes: element.mes,
              anio: element.anio,
              moneda: element.moneda,
              sucursal: element.sucursal,
              rutContratante: element.rutContratante,
              nombreContratante: element.nombreContratante,
              codigoRamo: element.codigoRamo,
              ramoFecu: element.ramoFecu,
              poliza: element.poliza,
              endoso: element.endoso,
              porcentajeComision: element.porcentajeComision,
              montoComision: element.montoComision,
              tipoComision: element.tipoComision,
              cambio: element.cambio,
              comisionNeta: element.comisionNeta,
              impuesto: element.impuesto,
              comisionTotal: element.comisionTotal,
              ajusteVersusFactura: element.ajusteVersusFactura,
              comisionAPago: element.comisionAPago,
              descuentoAnticipo: element.descuentoAnticipo,
              saldoAPagar: element.saldoAPagar,
              tipoDocumento: element.tipoDocumento,
              numeroDocumento: element.numeroDocumento,
              fechaFacturaBoleta: element.fechaFacturaBoleta,
              estado: element.estado,
            };
            archivoSalida.push(comision);
          });
          const archivo =
            "DetalleComisiones_" + new Date().toISOString().substr(0, 10);
          var conciliaciones = [];
          conciliaciones = XLSX.utils.json_to_sheet(archivoSalida);
          var libro = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(
            libro,
            conciliaciones,
            "DetalleComisiones"
          );
          XLSX.writeFile(libro, `${archivo}.xlsx`);
        });
    },
  },
};
</script>

<style>
.tabla-detalle-comision th {
  font-size: 10px !important;
}

.texto-derecha {
  text-align: right;
}
</style>
